import { Link } from 'react-router-dom';
import { articles } from '@/mocks/shows';

export default function FeaturedArticles() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">
              综艺资讯
            </h2>
            <p className="text-foreground-500 text-sm">
              最新综艺动态，一手掌握
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.views.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}